import { GenericStatus, GenericStatusColorType } from '../../shared/interfaces/generic-status';
import { SourceStatus } from '../../shared/interfaces/source';

export const SOURCE_STATUS_DATA_MAP: {
  [key in SourceStatus]: GenericStatus<SourceStatus>;
} = {
  [SourceStatus.FAILED]: {
    value: SourceStatus.FAILED,
    displayName: 'Failed',
    colorType: GenericStatusColorType.ERROR
  },
  [SourceStatus.ERRORED]: {
    value: SourceStatus.ERRORED,
    displayName: 'Errored',
    colorType: GenericStatusColorType.ERROR
  },
  [SourceStatus.CREATED]: {
    value: SourceStatus.CREATED,
    displayName: 'Created',
    colorType: GenericStatusColorType.DEFAULT
  },
  [SourceStatus.PAUSED]: {
    value: SourceStatus.PAUSED,
    displayName: 'Paused',
    colorType: GenericStatusColorType.DISABLED
  },
  [SourceStatus.ACTIVE]: {
    value: SourceStatus.ACTIVE,
    displayName: 'Active',
    colorType: GenericStatusColorType.DEFAULT
  },
  [SourceStatus.DELETING]: {
    value: SourceStatus.DELETING,
    displayName: 'Deleting',
    colorType: GenericStatusColorType.ERROR
  },
  [SourceStatus.DELETED]: {
    value: SourceStatus.DELETED,
    displayName: 'Deleted',
    colorType: GenericStatusColorType.ERROR
  }
};
